<template>
  <div>
    <statistics :item="groupList" :loading="loading"/>
    <a-row :gutter="[20,20]">
      <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12"><BugNum /></a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12"><StoreBugNum /></a-col>
    </a-row>
    <a-row class="m-t-20" :gutter="[20,20]">
      <a-col :span="24"><Map></Map></a-col>
    </a-row>
  </div>
</template>

<script>
import statistics from '../components/index/statistics.vue'
import { mapGetters } from 'vuex'
import bugIcon from '../components/index/icon/bugIcon'
import depotIcon from '../components/index/icon/depotIcon'
import storeBNumIcon from '../components/index/icon/storeBNumIcon'
import storeIcon from '../components/index/icon/storeIcon'
import storeNBNum from '../components/index/icon/storeNBNum'
import testIcon from '../components/index/icon/testIcon'
// import StoreNUm from '../components/index/report/storeNum'
import BugNum from '../components/index/report/bugNum'
import StoreBugNum from '../components/index/report/storeBugNum'
import Map from '../components/index/report/map'
export default {
  components: {
    statistics,
    // StoreNUm,
    BugNum,
    StoreBugNum,
    Map
  },
  data () {
    return {
      loading: true,
      depotNum: 0,
      storeBugNum: 0,
      storeNoBugNum: 0,
      bugNum: 0,
      testNum: 0
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    groupList () {
      return [{
        title: '粮库数量',
        num: this.depotNum,
        components: depotIcon
      },
      {
        title: '粮仓数量',
        num: this.storeBugNum + this.storeNoBugNum,
        components: storeIcon
      },
      {
        title: '粮虫数量',
        num: this.bugNum,
        components: bugIcon
      },
      {
        title: '有虫粮仓数量',
        num: this.storeBugNum,
        components: storeBNumIcon
      },
      {
        title: '无虫粮仓数量',
        num: this.storeNoBugNum,
        components: storeNBNum
      },
      {
        title: '累计检测',
        num: this.testNum,
        components: testIcon
      }]
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loading = true
      await Promise.all([
        this.getDepotNum(),
        this.getStoreBugNum(),
        this.getStoreNoBugNum(),
        this.getTestNum()
      ])
      this.loading = false
    },
    async getDepotNum () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          where: {
            hierarchy: {
              $inQuery: {
                where: {
                  tag: { $regex: '^' + this.userLevelTag }
                },
                className: 'hierarchy'
              }
            }
          },
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      this.depotNum = res.data.results.length
    },
    async getStoreBugNum () {
      const res = await this.$tkParse.get('/classes/grainStorehouse', {
        params: {
          where: {
            hierarchy: {
              $inQuery: {
                where: {
                  tag: { $regex: '^' + this.userLevelTag }
                },
                className: 'hierarchy'
              }
            },
            bugNum: {
              $gt: 0
            }
          },
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId,bugNum'
        }
      })
      this.storeBugNum = res.data.results.length
      this.bugNum = res.data.results.reduce((num, element) => num + element.bugNum, 0)
    },
    async getStoreNoBugNum () {
      const res = await this.$tkParse.get('/classes/grainStorehouse', {
        params: {
          where: {
            hierarchy: {
              $inQuery: {
                where: {
                  tag: { $regex: '^' + this.userLevelTag }
                },
                className: 'hierarchy'
              }
            },
            bugNum: 0
          },
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      this.storeNoBugNum = res.data.results.length
    },
    async getTestNum () {
      const res = await this.$tkParse.get('/classes/newTestResults', {
        params: {
          where: {
            hierarchy: {
              $inQuery: {
                where: {
                  tag: { $regex: '^' + this.userLevelTag }
                },
                className: 'hierarchy'
              }
            }
          },
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      this.testNum = res.data.results.length
    }
  }
}
</script>

<style>
</style>
